const people = [
  {
    location: "36 Lisgar St, Toronto, ON",
    time: "8:00 A.M - 10:00 P.M",
    contact: "(416)-450-2336",
    city: "Toronto Office",
    imageUrl: "/alpha_appraisals_team.webp",
    lastSeen: "1h ago",
    lastSeenDateTime: "2025-02-15",
    mapLink: "https://share.google/ms2CEARIqTum1xXun",
  },
  {
    location: "470 Chrysler Dr #20, Brampton, ON",
    time: "8:00 A.M - 10:00 P.M",
    contact: "(905)-794-6241",
    city: "Peel Office",
    imageUrl: "/mushtaq_khan_alpha_appraisals.webp",
    lastSeen: "2h ago",
    lastSeenDateTime: "2025-02-15",
    mapLink: "https://share.google/YX4ngzm3H0gI3Rvgs",
  }
];
export default function Offices() {
  function isPast10PM() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    return currentHour < 0; // Always returns false - keeps status as "Available"
  }

  const backgroundImageStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 0, 0),rgba(255, 255, 0, 0)), url('/office.webp')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <ul
      role="list"
      style={backgroundImageStyle}
      className="w-full sm:p-10 shadow-2xl rounded-b-3xl grid gap-x-8 p-12 lg:grid-cols-2"
    >
      {people.map((person) => (
        <li
          key={person.city}
          className="grid justify-center items-center gap-x-6 py-5 text-center sm:text-right"
        >
          <div className="sm:flex  flex-col md:text-left ">
 <a href={person.mapLink} target="_blank" rel="noopener noreferrer">
              <p className="text-xs md:text-left mb-2 font-light text-blue-500 hover:text-blue-700 transition-colors">View Maps Listing</p>
            </a>
            <a href={person.mapLink} target="_blank" rel="noopener noreferrer">
              <p className="text-2xl md:text-left sm:text-3xl border-blue-500 border-l-0 sm:border-l-8 pl-2 leading-6 font-semibold text-blue-500 hover:text-blue-700 transition-colors">
                {person.city}
              </p>
            </a>
          </div>
          <div className="flex gap-x-4 hover:text-yellow-900 text-black transition-colors duration-300 ease-in-out">
            <div className="min-w-0 flex-auto">
              <a href={person.mapLink} target="_blank" rel="noopener noreferrer">
                <p className="text-sm font-semibold leading-6 text-gray-900 hover:text-blue-700 transition-colors">
                  {person.location}
                </p>
              </a>
              <a href={`tel:${person.contact.replace(/[^0-9]/g, '')}`}>
                <p className="mt-1 truncate text-lg font-bold leading-5">
                  {person.contact}
                </p>
              </a>
              <p className="mt-1 truncate text-xs leading-5">{person.time}</p>
              <div className="mt-1 flex float-none align-middle justify-center items-center sm:float-right gap-x-1">
                <div className="flex-none text-right rounded-full bg-transparent p-1.5">
                  <div
                    className={`h-1.5 w-1.5 rounded-full animate-ping ${
                      isPast10PM() ? "bg-red-500" : "bg-yellow-600 dark:bg-blue-500"
                    }`}
                  />
                </div>
                <p
                  className={`text-xs leading-5 ${
                    isPast10PM() ? "text-red-500" : "text-gray-900 dark:text-blue-500"
                  }`}
                >
                  {isPast10PM() ? "Offline" : "Available"}
                </p>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
